import { BRIDGE_STALE_AFTER_MS } from './googleAdsBridgesConstants';

export const formatDate = (value) => (value ? new Date(value).toLocaleString() : 'never');

// Account ids arrive as 10 digits or already dashed; anything else is returned as is so the validator can flag it
export const formatCustomerId = (value) => {
  if (value === null || value === undefined) return '';
  const digits = String(value).replace(/\D/g, '');
  return digits.length === 10 ? `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}` : String(value);
};

export const isStale = (value) => !value || Date.now() - new Date(value).getTime() > BRIDGE_STALE_AFTER_MS;

// the once-shown secret can sit in the react-admin cache after a create; never send it back
export const stripSecret = ({ secret, secret_enc, ...rest }) => rest;
